export default {"src":"/_next/static/media/rocket-with-bg.a4611985.svg","height":68,"width":68,"blurWidth":0,"blurHeight":0};